import { Stack, Typography } from "@mui/material";
import { HStack } from "Components/_Shared/Core/Stack";
import { Dot } from "Components/_Shared/Dot";
import type { GoalOverview } from "Infrastructure/ApiZfp/Schema";
import { Spacing } from "Infrastructure/Themes/Themes";
import { useResource } from "Infrastructure/Translations/Resources";
import { formatCurrencyShortText } from "Infrastructure/Utils/CurrencyUtils";
import type { ReactNode } from "react";
import { getTimeDurationFormatted } from "../helpers";
import { GoalIcon } from "./GoalIcon";
import { getGoalTargetAmount } from "./utils";

type Props = {
  goal: GoalOverview;
  extra?: ReactNode;
};

export const GoalLabel = ({ goal, extra }: Props) => {
  const { t } = useResource();

  const amount = getGoalTargetAmount(goal);

  return (
    <HStack spacing={Spacing.L} sx={{ display: "inline-flex" }}>
      {goal.type && (
        <Typography color="primary.main">
          <GoalIcon type={goal.type} />
        </Typography>
      )}
      <Stack spacing={Spacing.M}>
        <HStack gap={Spacing.M} alignItems={"center"} divider={<Dot />}>
          <Typography variant="body2" color={"textPrimary"} fontWeight={600}>
            {`${goal.name}${amount !== null && amount !== undefined ? ` (${formatCurrencyShortText(amount)})` : ""}`}
          </Typography>
          <Typography variant="caption" color={"textSecondary"}>
            {getTimeDurationFormatted(goal.horizonDuration, t)}
          </Typography>
        </HStack>
        {extra}
      </Stack>
    </HStack>
  );
};
